import React from "react";
import PeriodSelector from "components/PeriodSelector";
import SplitView from "design/layouts/SplitView";
import Right from "design/layouts/Right";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import ExportButton from "design/components/buttons/ExportButton";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useStyles = makeThemedStyles("ToolbarWithButton", (theme) => ({
  rightSide: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
}));

const ToolbarWithButton = (
  props: React.PropsWithChildren<{
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  }>
) => {
  const { onClick } = props;
  const classes = useStyles();

  return (
    <ToolbarContainer>
      <SplitView partCnt={2}>
        <ToolbarTitle>{props.children}</ToolbarTitle>
        <Right>
          <div className={classes.rightSide}>
            <PeriodSelector level="Month" />
            <ExportButton onClick={onClick} title="Export Dashboard" />
          </div>
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default ToolbarWithButton;
